<template>
  <div class="login-wrap">
    <!-- 顶部导航栏 -->
    <header class="login-header">
      <div class="logo-bar">
        <img
          src="@/assets/login/icon_logo.png"
          alt="新致软件"
          class="logo-img"
        />
        <span class="logo-text">新致软件</span>
      </div>
      <div class="header-right">
        <a
          class="link-home"
          href="https://newtouch.com/#/"
          target="_blank"
          rel="noopener noreferrer"
          >官网首页</a
        >
        <!-- <a-button type="primary" class="btn-login-top">登录</a-button> -->
      </div>
    </header>

    <!-- 主体左右分栏 -->
    <main class="login-main">
      <!-- 左侧3D插画区域 -->
      <section class="login-left">
        <div class="illustration-box"></div>
      </section>

      <!-- 右侧登录表单区域 -->
      <section class="login-right">
        <div class="form-container">
          <div class="brand-title">
            <img
              src="@/assets/icons/logo.png"
              alt="新致软件"
              class="logo-img2"
            />
            <h2 class="cn-brand">新知智法.AI法律助手</h2>
            <p class="brand-desc">
              新知智法.AI法律助手助力司法研究与司法实践，开启您的智慧司法之旅！
            </p>
          </div>

          <a-form
            :model="phoneForm"
            layout="vertical"
            @finish="handlePhoneLogin"
          >
            <!-- 手机号 -->
            <a-form-item
              name="phone"
              label="手机号"
              :rules="[{ required: true, message: '请输入手机号' }]"
            >
              <a-input
                v-model:value="phoneForm.phone"
                size="large"
                placeholder="手机号"
                class="custom-input"
              >
                <template #prefix>
                  <PhoneOutlined />
                </template>
              </a-input>
            </a-form-item>

            <!-- 验证码 -->
            <a-form-item
              name="code"
              label="验证码"
              :rules="[{ required: true, message: '请输入验证码' }]"
            >
              <div class="captcha-wrapper">
                <a-input
                  v-model:value="phoneForm.code"
                  size="large"
                  placeholder="验证码"
                  class="custom-input"
                >
                  <template #prefix>
                    <MailOutlined />
                  </template>
                </a-input>
                <a-button
                  :disabled="captchaDisabled"
                  @click="getCaptcha"
                  class="captcha-button"
                >
                  {{ captchaText }}
                </a-button>
              </div>
            </a-form-item>

            <!-- 登录按钮 -->
            <a-button
              html-type="submit"
              size="large"
              block
              :loading="loading"
              class="login-button"
            >
              登录
            </a-button>
          </a-form>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons-vue";
import {
  getTokenUser,
  sendSmsCode,
  loginByPhone,
  oauthAuthorize,
} from "@/api/userapi";
import { getUserPermissions } from "@/api/baseapi";

const loading = ref(false);
const router = useRouter();
// const activeTab = ref('phone')

// 从 URL 查询参数获取 OAuth 信息
const oauthParams = ref(null);

onMounted(() => {
  const search = window.location.search;
  if (search) {
    const params = new URLSearchParams(search);
    const client_id = params.get("client_id");
    const redirect_uri = params.get("redirect_uri");
    const state = params.get("state");
    const response_type = params.get("response_type");
    const code_challenge = params.get("code_challenge");
    const code_challenge_method = params.get("code_challenge_method");
    if (client_id || redirect_uri || state) {
      oauthParams.value = {
        client_id,
        redirect_uri,
        state,
        response_type,
        code_challenge,
        code_challenge_method,
      };
      console.log("OAuth 参数:", oauthParams.value);
    }
  }
});

// // 密码登录表单
// const passwordForm = reactive({
//   account: '',
//   password: '',
//   tenantId: '1000',
//   remember: false
// })

// 手机号登录表单
const phoneForm = reactive({
  phone: "",
  code: "",
  tenantId: "1000",
});

// 验证码按钮状态
const captchaDisabled = ref(false);
const captchaText = ref("获取验证码");

// 获取验证码
const getCaptcha = () => {
  if (!phoneForm.phone) {
    message.warning("请输入手机号");
    return;
  }
  const phoneRegex = /^1[3-9]\d{9}$/;
  if (!phoneRegex.test(phoneForm.phone)) {
    message.warning("请输入正确的手机号");
    return;
  }

  // 调用发送验证码接口
  sendSmsCode(phoneForm.phone)
    .then(() => {
      captchaDisabled.value = true;
      let count = 60;
      captchaText.value = `${count}秒后重试`;

      const timer = setInterval(() => {
        count--;
        if (count <= 0) {
          clearInterval(timer);
          captchaDisabled.value = false;
          captchaText.value = "获取验证码";
        } else {
          captchaText.value = `${count}秒后重试`;
        }
      }, 1000);

      message.success("验证码已发送，请注意查收");
    })
    .catch(() => {
      message.error("验证码发送失败，请稍后重试");
    });
};

// 密码登录
// const handlePasswordLogin = () => {
//   if (!passwordForm.account) {
//     message.warning('请输入账号')
//     return
//   }
//   if (!passwordForm.password) {
//     message.warning('请输入密码')
//     return
//   }

//   loading.value = true
//   login(passwordForm.account, passwordForm.password, passwordForm.tenantId)
//     .then((response) => {
//       if (response.code === 200 && response.isSuccess) {
//         localStorage.setItem('token', response.data)
//         getTokenUser().then((res) => {
//           if (res.code === 200) {
//             localStorage.setItem('user', JSON.stringify(res.data))
//           }
//         })
//         getUserPermissions().then((res) => {
//           if (res.code === 200) {
//             localStorage.setItem('UserPermissions', JSON.stringify(res.data))
//           }
//         })
//         if (passwordForm.remember) {
//           localStorage.setItem('savedLoginInfo', JSON.stringify({
//             username: passwordForm.account,
//             password: passwordForm.password,
//             remember: true
//           }))
//         } else {
//           localStorage.removeItem('savedLoginInfo')
//         }
//         message.success('登录成功！')
//         setTimeout(() => {
//           loading.value = false
//           router.push('/home')
//         }, 1000)
//       } else {
//         message.error(response.errMsg || '登录失败')
//         loading.value = false
//       }
//     })
//     .catch((error) => {
//       console.error('Login request failed:', error)
//       message.error('登录请求失败，请稍后重试')
//       loading.value = false
//     })
// }

// 手机号登录
const handlePhoneLogin = () => {
  if (!phoneForm.phone) {
    message.warning("请输入手机号");
    return;
  }
  if (!phoneForm.code) {
    message.warning("请输入验证码");
    return;
  }

  loading.value = true;
  loginByPhone(phoneForm.phone, phoneForm.code, phoneForm.tenantId)
    .then(async (response) => {
      if (response.code === 200 && response.isSuccess) {
        localStorage.setItem("token", response.data);
        await getTokenUser().then((res) => {
          if (res.code === 200) {
            localStorage.setItem("user", JSON.stringify(res.data));
          }
        });
        await getUserPermissions().then((res) => {
          if (res.code === 200) {
            localStorage.setItem("UserPermissions", JSON.stringify(res.data));
          }
        });
        message.success("登录成功！");
        setTimeout(() => {
          loading.value = false;
          router.push("/home");
        }, 1000);
        // 有 OAuth 参数：调用 /oauth/authorize 并处理返回的 HTML 跳转
        if (oauthParams.value) {
          try {
            const oauthRes = await oauthAuthorize(oauthParams.value);
            console.log(oauthRes, "oauthAuthorize");
            // 返回的是 HTML 页面，包含 location.href 跳转脚本
            // 后端可能使用单引号或双引号包裹 URL，需要同时兼容
            if (
              typeof oauthRes === "string" &&
              oauthRes.includes("location.href")
            ) {
              const match = oauthRes.match(
                /location\.href\s*=\s*['"]([^'"]+)['"]/,
              );
              if (match && match[1]) {
                console.log("PhoneLogin 跳转 URL:", match[1]);
                // window.location.href = match[1]
                window.open(match[1], "_blank");
                return;
              }
            }
            // 如果到这里说明没有匹配到跳转 URL
            message.error("授权失败：未获取到有效的跳转地址");
          } catch (err) {
            console.error("OAuth 授权失败", err);
            message.error("授权服务连接失败，请确认后端服务是否正常运行");
          }
          loading.value = false;
          return;
        }
      } else {
        message.error(response.errMsg || "登录失败");
        loading.value = false;
      }
    })
    .catch((error) => {
      console.error("Phone login failed:", error);
      message.error("登录请求失败，请稍后重试");
      loading.value = false;
    });
};
</script>

<style scoped lang="less">
// 全局主题变量
:root {
  --primary-blue: #1677ff;
  --light-bg: #f7faff;
  --text-dark: #1a1a1a;
  --text-gray: #8c8c8c;
  --border-light: #e6edf7;
  --white: #ffffff;
}

.login-wrap {
  width: 100vw;
  height: 100vh;
  background: var(--white);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 顶部导航栏
.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  flex-shrink: 0;

  .logo-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    .logo-img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
    .logo-text {
      font-size: 16px;
      font-weight: 500;
      color: var(--text-dark);
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 24px;
    .link-home {
      // color: var(--primary-blue);
      font-size: 14px;
      cursor: pointer;
      text-decoration: none; // 移除默认下划线
      &:hover {
        text-decoration: none; // 鼠标悬浮也不显示下划线
      }
    }
    .btn-login-top {
      padding: 0 20px;
      height: 36px;
      border-radius: 6px;
      background: #145dff;
    }
  }
}

// 主体左右布局
.login-main {
  flex: 1;
  display: grid;
  grid-template-columns: 60% 40%;
  overflow: hidden;
  background-image: url("@/assets/login/icon_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

// 左侧插画区域
.login-left {
  //   background: linear-gradient(120deg, #e8f0ff 0%, #f0f6ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  .illustration-box {
    width: 85%;
    height: 85%;
  }
}

// 右侧表单区域
.login-right {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 60px;
  background-image: url("@/assets/login/icon_bg2.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  .form-container {
    width: 100%;
    max-width: 420px;
  }
}

// 品牌标题区
.brand-title {
  margin-bottom: 40px;
  .en-brand {
    font-size: 28px;
    font-weight: 600;
    color: var(--primary-blue);
    letter-spacing: 1px;
    display: block;
    margin-bottom: 6px;
  }
  .cn-brand {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #000000;
  }
  .brand-desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #929aa6;
    line-height: 25px;
    margin-bottom: 67px;
  }
}

// 登录 tab 样式
.login-tabs {
  margin-bottom: 0;
  :deep(.ant-tabs-nav) {
    margin-bottom: 24px;
    &::before {
      border-bottom: none;
    }
  }
  :deep(.ant-tabs-tab) {
    font-size: 16px;
    padding: 8px 0;
    margin-right: 32px;
  }
}

// 验证码输入框 + 按钮
.captcha-wrapper {
  display: flex;
  gap: 12px;
  .custom-input {
    flex: 1;
  }
  .captcha-button {
    flex-shrink: 0;
    height: 48px;
    border-radius: 12px;
    padding: 0 16px;
    font-size: 14px;
    background: #155dff;
    color: #fff;
    border: none;
    &:disabled {
      background: #d9d9d9;
      color: #999;
    }
  }
}

.logo-img2 {
  width: 163px;
  height: 26px;
  margin: 12px 0;
}
// 表单通用样式
.login-form {
  .ant-form-item {
    margin-bottom: 22px;
  }
  :deep(.ant-input),
  :deep(.ant-input-password) {
    height: 44px;
    border-radius: 8px;
    border: 1px solid var(--border-light);
    font-size: 14px;
    background: #f5fafe;
  }
  :deep(.ant-input-prefix) {
    color: var(--text-gray);
    font-size: 16px;
  }
}

// 记住我+忘记密码行
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  .forgot-link {
    color: var(--primary-blue);
    font-size: 14px;
  }
}

// 登录主按钮
.login-button {
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: #155dff;
  color: #fff;
}

// custom-input 覆盖 ant-input 输入框样式
:deep(.custom-input) {
  height: 48px;
  border-radius: 12px;
  border: 1px solid #e5e8ef;
  background: #f5fafe;
  padding: 0 13px;
  font-size: 16px;
  color: #333;
}
// 密码输入框的外层包装也加边框
:deep(.ant-input-affix-wrapper.custom-input) {
  border: 1px solid #e5e8ef !important;
  border-radius: 12px;
  background: #f5fafe;
  padding: 0 13px;
}
:deep(.ant-input-affix-wrapper.custom-input .ant-input) {
  background: transparent;
  border: none !important;
  box-shadow: none;
}
:deep(.custom-input .ant-input-prefix) {
  margin-right: 10px;
  color: #999;
  font-size: 18px;
}
// 注册底部提示
.register-tip {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: var(--text-gray);
  .link-register {
    color: #155dff;
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
